import { render, staticRenderFns } from "./GenericAssetsRelationTab.vue?vue&type=template&id=33fac365&scoped=true&"
import script from "./GenericAssetsRelationTab.vue?vue&type=script&lang=js&"
export * from "./GenericAssetsRelationTab.vue?vue&type=script&lang=js&"
import style0 from "./GenericAssetsRelationTab.vue?vue&type=style&index=0&id=33fac365&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fac365",
  null
  
)

export default component.exports